import type { NotificationEntity } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  entityEvent,
  entityId,
  entityType,
  createdAt,
  ...rest
}: Common.OutSchema): NotificationEntity.Schema {
  return {
    ...rest,
    entity: {
      id: entityId ?? EMPTY,
      name: entityType,
    },
    action: entityEvent,
    createdAt: new Date(createdAt),
  };
}

export { mapDtoToEntity };
